import { Controller } from 'react-hook-form'

import { NO, YES, useFormContextPatient } from '../_utils'
import PatientFormField from '../PatientFormField'
import { shouldDirty } from '../PatientIdentity/_utils/_utils'

const HasCss = () => {
    const { control, setValue } = useFormContextPatient()

    return (
        <Controller
            control={control}
            name="hasCss"
            render={({ field, fieldState: { error } }) => {
                const isSet = field.value === true || field.value === false
                let selectValue: 'YES' | 'NO' | undefined
                let label: string | undefined
                if (isSet) {
                    selectValue = field.value ? 'YES' : 'NO'
                    label = field.value ? YES : NO
                }

                return (
                    <PatientFormField<'YES' | 'NO'>
                        variant="select"
                        type="default"
                        label="Le patient bénéficie-t-il de la CSS ?"
                        name={field.name}
                        status={{
                            error,
                            valid: isSet,
                            warning: !isSet,
                        }}
                        required
                        warningMessage={!isSet ? 'Cette information n’a pas encore été complétée' : undefined}
                        clearable={false}
                        placeholder="Choisir"
                        value={selectValue}
                        renderLabel={() => label}
                        dataCyScope="PatientField"
                        onChange={(e) => {
                            if (e === 'YES') {
                                setValue('hasCss', true, shouldDirty)
                            } else if (e === 'NO') {
                                setValue('hasCss', false, shouldDirty)
                            }
                        }}
                        options={[
                            { label: YES, value: 'YES' },
                            { label: NO, value: 'NO' },
                        ]}
                    />
                )
            }}
        />
    )
}

export default HasCss
